export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseDashboardUrl = process.env.REACT_APP_BASE_DASHBOARD_URL;

export const api = {
  auth: {
    login: 'auth/login',
    register: 'auth/register',
    config: 'vars',
    updateUser: 'users/update',
    forgotPassword: 'auth/forgot-password',
    resetPassword: 'auth/reset-password',
  },
  news: {
    list: 'news/tabs',
    search: 'news/search',
    newsDetails: 'news',
    drugDetails: 'drugs',
    drugsSearch: 'drugs/search',
  },
  content: {
    changePassword: 'auth/change-password',
    recommendations: 'news',
    recommendationsDetails: 'recommendations',
    recommendationsByTab: 'recommendations/tab',
    home: 'home',
  },
  qna: {
    ask: 'qna/ask',
  },
  summaries: {
    getById: 'summaries/',
    getByTab: 'summaries/tab',
    getByDateRange: 'summaries/date-range',
    generateVoice: 'summaries/generate-voice-summary',
  },
  translate: {
    googleTranslate: 'api/google-translate',
  },
  dashboard: {
    login: 'login',
    domains: 'domains',
    speciality: 'autocomplete/speciality',
    typeOfStudy: 'autocomplete/type_of_study',
    scrape: 'scrape',
  },
};
